import React from 'react';
import PropTypes from 'prop-types';
import { Autocomplete } from '@totalsoft/rocket-ui';
import { useTranslation } from 'react-i18next';
import { Grid, FormControlLabel, Checkbox } from '@mui/material';
import { isValid, getErrors } from '@totalsoft/pure-validations-react';

const AutomaticStateTransitionGeneralDataComponent = ({ automaticStateTransition, docTypes, states, onPropertyChanged, validation }) => {
  const { t } = useTranslation();

  return (
    <Grid container spacing={3}>
      <Grid item xs={5} sm={5} md={5}>
        <Autocomplete
          fullWidth
          simpleValue={true}
          label={t('AutomaticStateTransitions.DocumentType')}
          value={automaticStateTransition.documentTypeId}
          options={docTypes}
          onChange={event => {
            onPropertyChanged('documentTypeId', event);
          }}
          error={!isValid(validation.documentTypeId)}
          helperText={getErrors(validation.documentTypeId)}
        />
      </Grid>
      <Grid item xs={5} sm={5} md={5}>
        <Autocomplete
          fullWidth
          simpleValue={true}
          label={t('AutomaticStateTransitions.InitialState')}
          value={automaticStateTransition.fromStateId}
          options={states && automaticStateTransition ? states.allowedStates : []}
          onChange={event => {
            onPropertyChanged('fromStateId', event);
          }}
          valueKey='documentStateId'
          labelKey='documentStateName'
          error={!isValid(validation.fromStateId)}
          helperText={getErrors(validation.fromStateId)}
        />
      </Grid>
      <Grid item xs={2} sm={2} md={2}>
        <FormControlLabel
          control={
            <Checkbox
              checked={automaticStateTransition.inactive || false}
              onChange={event => onPropertyChanged('inactive', event.target.checked)}
            />
          }
          label={t('AutomaticStateTransitions.Inactive')}
          labelPlacement='end'
          sx={{ paddingLeft: 1, paddingTop: 1 }}
        />
      </Grid>
    </Grid>
  );
};

AutomaticStateTransitionGeneralDataComponent.propTypes = {
  automaticStateTransition: PropTypes.object.isRequired,
  states: PropTypes.object,
  docTypes: PropTypes.array.isRequired,
  onPropertyChanged: PropTypes.func.isRequired,
  validation: PropTypes.object.isRequired
};

export default AutomaticStateTransitionGeneralDataComponent;
